'use client';

import { c as _c } from "react/compiler-runtime";
import LoginRounded from '@mui/icons-material/LoginRounded';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import resoneticsLogoUrl from '@/public/resonetics.svg';
import Image from 'next/image';
import Typography from '@mui/material/Typography';
import { signIn, useSession } from 'next-auth/react';
import * as colors from '@mui/material/colors';
import { useQueryState } from 'nuqs';
import { useState } from 'react';
import { ROUTES } from '@/app/routes';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import LockOutlined from '@mui/icons-material/LockOutlined';
export const Login: React.FC<{
  enableE2eTests: boolean;
}> = t0 => {
  const $ = _c(28);
  const {
    enableE2eTests
  } = t0;
  const {
    status
  } = useSession();
  const isLoading = status === "loading";
  const [error] = useQueryState("error");
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      username: "",
      password: ""
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [testCredentials, setTestCredentials] = useState(t1);
  const [isTestLoading, setIsTestLoading] = useState(false);
  let t2;
  if ($[1] !== testCredentials.password || $[2] !== testCredentials.username) {
    t2 = async e => {
      e.preventDefault();
      setIsTestLoading(true);
      const result = await signIn("test-credentials", {
        username: testCredentials.username,
        password: testCredentials.password,
        callbackUrl: ROUTES.ppt.base,
        redirect: false
      });
      setIsTestLoading(false);
      if (result?.error) {
        console.error("Test login failed:", result.error);
        return;
      }
      if (result?.url) {
        window.location.href = result.url;
      }
    };
    $[1] = testCredentials.password;
    $[2] = testCredentials.username;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleTestLogin = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      display: "flex",
      mx: "auto",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "100vh",
      mt: -7
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Avatar sx={{
      bgcolor: "secondary.main",
      width: 60,
      height: 60
    }}><LockOutlined fontSize="large" /></Avatar>;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Image src={resoneticsLogoUrl} height={150} width={600} alt="Resonetics" style={{
      aspectRatio: 1
    }} />;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <LoginRounded />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const t7 = isLoading ? colors.grey[500] : "primary.main";
  let t8;
  if ($[8] !== t7) {
    t8 = {
      bgcolor: t7
    };
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== isLoading) {
    t9 = isLoading ? <CircularProgress size={26} sx={{
      color: "common.white"
    }} /> : "Sign In";
    $[10] = isLoading;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isLoading || $[13] !== t8 || $[14] !== t9) {
    t10 = <Button size="large" disabled={isLoading} onClick={_temp} variant="contained" fullWidth={true} endIcon={t6} sx={t8}>{t9}</Button>;
    $[12] = isLoading;
    $[13] = t8;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== enableE2eTests || $[17] !== handleTestLogin || $[18] !== isTestLoading || $[19] !== testCredentials.password || $[20] !== testCredentials.username) {
    t11 = enableE2eTests && <Box component="form" onSubmit={handleTestLogin} sx={{
      display: "none",
      mt: 3,
      p: 2,
      border: "1px solid #ddd",
      borderRadius: 1,
      bgcolor: "#f9f9f9",
      width: "100%"
    }} data-testid="test-login-form"><TextField id="test-username" data-testid="test-username" name="username" placeholder="Test Username" size="small" fullWidth={true} value={testCredentials.username} onChange={e_0 => setTestCredentials(prev => ({
        ...prev,
        username: e_0.target.value
      }))} disabled={isTestLoading} sx={{
        mb: 2
      }} /><TextField id="test-password" data-testid="test-password" name="password" type="password" placeholder="Test Password" size="small" fullWidth={true} value={testCredentials.password} onChange={e_1 => setTestCredentials(prev_0 => ({
        ...prev_0,
        password: e_1.target.value
      }))} disabled={isTestLoading} sx={{
        mb: 2
      }} /><Button id="test-login-button" data-testid="test-login-button" type="submit" variant="outlined" size="small" disabled={isTestLoading} sx={{
        width: "auto"
      }}>Test Login</Button></Box>;
    $[16] = enableE2eTests;
    $[17] = handleTestLogin;
    $[18] = isTestLoading;
    $[19] = testCredentials.password;
    $[20] = testCredentials.username;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== error) {
    t12 = error ? <Typography color="error" fontWeight={500} bgcolor={colors.yellow[100]} borderRadius={4} px={3} py={2} mt={3}>Error: {error}</Typography> : null;
    $[22] = error;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t11 || $[26] !== t12) {
    t13 = <Container component="main" maxWidth="xs" sx={t3}>{t4}{t5}{t10}{t11}{t12}</Container>;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
  } else {
    t13 = $[27];
  }
  return t13;
};
function _temp() {
  return signIn("azure-ad", {
    callbackUrl: ROUTES.ppt.base
  });
}